import uuid from 'react-uuid'

/**
 * Reload the page if the current page is the route given as paramter
 *
 * @param [String] route the route we are trying to reload
 */
export function reloadIfCurrentRoute(route) {
  if (window && window.location.pathname === route) {
    window.location.href = route
  }
}

// for use with Optimizely
export function optimizelyUserId() {
  if (typeof window !== 'undefined' && window.localStorage) {
    let userId = localStorage.getItem('userId')
    if (!userId) {
      userId = uuid()
      localStorage.setItem('userId', userId)
    }
    return userId
  }
  return null
}

export function passOptimizelyParam(response, decision, experimentName) {
  let url
  try {
    url = new URL(response?.destination)
  } catch (e) {
    return response
  }
  // key is experiment name with 'opex' prefix - 'opex' = 'optimizely experiment'
  url.searchParams.append(`opex_${experimentName}`, decision?.variationKey || '')
  response.destination = url.toString()
  return response
}
